import React from 'react'
import styled, { ThemeProps, DefaultTheme } from 'styled-components'
import { Link } from 'react-router-dom'
import { mediaPc } from '../../../lib/MediaQuery'
import { isJustOnly } from '../../../config'
import {
  UserHomeSlider,
  HomeTopBanner,
  HomeCreatorRecruitmentBanner,
  CreatorSearch,
  HomeCreatorRanking,
  HomeFavoriteNew,
  HomeProductsOnSale,
} from '../../organisms'
import { CreatorRanking, PublishedProduct } from '../../../types/graphql'

/* images */
import { ReactComponent as RegisterLinkIcon } from '../../../assets/images/icon/register-link.svg'
import { ReactComponent as ArrowIcon } from '../../../assets/images/icon/arrow-green.svg'

type Props = {
  searchWord: string
  creatorRanking: CreatorRanking[]
  selectedDuration: 'weekly' | 'monthly'
  favoriteNewProducts: PublishedProduct[]
  productsOnSale: PublishedProduct[]
  isLoggedIn: boolean
  isTokenValid: boolean
  onClickSearchButton: () => void
  onChangeSearchWord: (event: React.ChangeEvent<HTMLInputElement>) => void
  onChangeDuration: (durationType: 'weekly' | 'monthly') => void
  onClickFavorite: (creatorId: string, isFavorite: boolean) => void
}

const Wrapper = styled.div`
  .creator-ranking,
  .favorite-new,
  .products-on-sale {
    padding: 10vw 4.8vw 6vw;
  }

  .register-link {
    display: flex;
    align-items: center;
    width: 92.27vw;
    height: 13.6vw;
    margin: 5.87vw auto 0;
    padding: 0 3.47vw;
    border-radius: 2.13vw;
    font-size: 3.47vw;
    color: ${(props): string => props.theme.textColors.black};
    border: 0.53vw solid ${(props): string => props.theme.textColors.primary};
    &:hover {
      opacity: 0.8;
    }
    .register-icon {
      width: 5.6vw;
      margin: 0 2.13vw 0 0;
    }
    p {
      font-weight: 700;
      letter-spacing: 0.1em;
    }
    .arrow-icon {
      width: 1.6vw;
      margin-left: auto;
    }
  }
  ${mediaPc`
    width: 100%;
    overflow: hidden;
    .creator-ranking {
      padding: 64px 20px 0;
    }
    .creator-ranking,.favorite-new, .products-on-sale  {
      width: 1040px;
      margin: 0 auto 95px;
    }
    .favorite-new, .products-on-sale{
      padding: 0 20px;
    }
    .register-link {
      width: 675px;
      height: 90px;
      margin: 26px auto 0;
      padding: 0 29px 0 41px;
      border-radius: 18px;
      font-size: 24px;
      border: 4px solid ${(props: ThemeProps<DefaultTheme>): string => props.theme.backgroundColors.primary};
      .register-icon {
        width: 32px;
        margin: 0 21px 0 0;
      }
      p {
        font-weight: 700;
      }
      .arrow-icon {
        width: 13px;
      }
    }
  `}
`

export const UserHomeTpl: React.FC<Props> = ({
  searchWord,
  creatorRanking,
  selectedDuration,
  favoriteNewProducts,
  productsOnSale,
  isLoggedIn,
  isTokenValid,
  onChangeSearchWord,
  onClickSearchButton,
  onChangeDuration,
  onClickFavorite,
}) => {
  return (
    <Wrapper>
      <HomeTopBanner />
      <UserHomeSlider />
      {!isLoggedIn && (
        <Link className="register-link" to="/registration">
          <RegisterLinkIcon className="register-icon" />
          <p>アカウント新規登録(無料)はこちらから！</p>
          <ArrowIcon className="arrow-icon" />
        </Link>
      )}
      {isJustOnly() && <HomeCreatorRecruitmentBanner />}
      <HomeCreatorRanking
        selectedDuration={selectedDuration}
        creatorRanking={creatorRanking}
        onChangeDuration={onChangeDuration}
        onClickFavorite={onClickFavorite}
        className="creator-ranking"
      />
      {isLoggedIn && isTokenValid && <HomeFavoriteNew className="favorite-new" favoriteNewProducts={favoriteNewProducts} />}
      <HomeProductsOnSale className="products-on-sale" productsOnSale={productsOnSale} />
      <CreatorSearch searchWord={searchWord} onChange={onChangeSearchWord} onClick={onClickSearchButton} className="sp" />
    </Wrapper>
  )
}
